module.exports = __webpack_public_path__ + "img/dating.abf0426.png";